import React, { useEffect, useState } from "react";
import { getGallery } from "../Service/Api";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
const Gallery = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const galleryData = await getGallery();
        setData(galleryData);
      } catch (error) {
        console.log("Error fetching gallery data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const empty = [
    {
      title: "Gallery Title",
      img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/gallery1.png",
    },
    {
      title: "Gallery Title",
      img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/gallery2.png",
    },
    {
      title: "Gallery Title",
      img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/gallery3.png",
    },
    {
      title: "Gallery Title",
      img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/gallery4.png",
    },
  ];

  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="row">
        <Slider {...settings}>
          {data.length > 0
            ? data.map((item, index) => (
                <div className="item" key={index}>
                  <div className="galleryimg">
                    <div className="galleryimgbox">
                      <LazyLoad>
                        {" "}
                        <img
                          src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                          className="img-fluid"
                          alt="Cannosa school"
                        />
                      </LazyLoad>
                      <div className="gallerydesc">
                        <h6>{item.title}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : empty.map((item) => (
                <div className="item" key={item.id}>
                  <div className="galleryimg">
                    <div className="galleryimgbox">
                      <LazyLoad>
                        <img
                          src={item.img}
                          className="img-fluid"
                          alt="Cannosa school"
                        />
                      </LazyLoad>
                      <div className="gallerydesc">
                        <h6>{item.title}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
        </Slider>
      </div>
    </>
  );
};

export default Gallery;
